import { reactive, onBeforeMount } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5736f135"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search_wrap"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "btn-content"
};
import useGetSelect from '@/hooks/useGetSelect';
import { searchFields } from '@/common';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBlock',
  props: {
    payStatusList: {
      type: Array,
      defualt: () => []
    },
    orderTypeList: {
      type: Array,
      defualt: () => []
    }
  },
  emits: ['search'],
  setup(__props, {
    emit
  }) {
    const {
      productSelectRef,
      getDbtProducts
    } = useGetSelect(); // 接口数据源相关一系列内容
    const filterOption = reactive({
      dbtId: undefined,
      orderNo: '',
      prodId: '',
      payMethod: undefined,
      payStatusList: []
    });
    const changeDbtId = () => {
      onSearch();
    }; // 变更选择的产品
    const onSearch = () => {
      emit('search', {
        ...filterOption
      });
    };
    const reset = () => {
      filterOption.dbtId = undefined;
      filterOption.orderNo = '';
      filterOption.prodId = '';
      filterOption.payMethod = undefined;
      filterOption.payStatusList = [];
      onSearch();
    };
    onBeforeMount(async () => {
      getDbtProducts(); // 产品下拉接口
    });
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: filterOption.dbtId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filterOption.dbtId = $event),
        multiple: false,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        "allow-clear": false,
        layout: "vertical",
        descriptionField: "filePath",
        width: 200,
        placeholder: "请选择产品",
        onChange: changeDbtId,
        "show-bottom-border": ""
      }, null, 8, ["modelValue", "search-fields"]), _createVNode(_component_a_input_search, {
        class: "filter_item filter_order_no",
        value: filterOption.orderNo,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => filterOption.orderNo = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "订单号查询",
        onSearch: onSearch
      }, null, 8, ["value"]), _createVNode(_component_a_input_search, {
        class: "filter_item",
        value: filterOption.prodId,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => filterOption.prodId = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "商品ID查询",
        onSearch: onSearch
      }, null, 8, ["value"]), _createVNode(_component_a_select, {
        class: "filter_item",
        "show-arrow": "",
        "allow-clear": "",
        value: filterOption.payMethod,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => filterOption.payMethod = $event),
        placeholder: "请选择订单类型",
        options: __props.orderTypeList
      }, null, 8, ["value", "options"]), _createVNode(_component_a_select, {
        class: "filter_item",
        mode: "multiple",
        "show-arrow": "",
        "allow-clear": "",
        value: filterOption.payStatusList,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => filterOption.payStatusList = $event),
        placeholder: "请选择支付状态(多选)",
        options: __props.payStatusList
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_button, {
        onClick: reset,
        class: "reset_btn"
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        onClick: onSearch,
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])]);
    };
  }
});